import { render } from "./ProgramsDetails.vue?vue&type=template&id=4d8deaf8&scoped=true"
import script from "./ProgramsDetails.vue?vue&type=script&lang=js"
export * from "./ProgramsDetails.vue?vue&type=script&lang=js"

import "./ProgramsDetails.vue?vue&type=style&index=0&id=4d8deaf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8deaf8"]])

export default __exports__